import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '@axmit/error-helper';
import { AppDispatch } from 'app/store';
import { announcementTransport } from 'entities/Announcement/Announcement.transport';
import { IAnnouncementModel } from 'entities/Announcement/Announcement.models';

export interface IState {
  activeAnnouncementsLoading: boolean;
  activeAnnouncements: IAnnouncementModel[];
  activeAnnouncementsError: IError | null;
}

const initialState: IState = {
  activeAnnouncementsLoading: false,
  activeAnnouncements: [],
  activeAnnouncementsError: null,
};

export const announcementSlice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    setActiveAnnouncementsLoading(state, action: PayloadAction<boolean>) {
      state.activeAnnouncementsLoading = action.payload;
    },
    setActiveAnnouncements(state, action: PayloadAction<IAnnouncementModel[]>) {
      state.activeAnnouncements = action.payload;
    },
    setActiveAnnouncementsError(state, action: PayloadAction<IError | null>) {
      state.activeAnnouncementsError = action.payload;
    },
    clearActiveAnnouncements(state) {
      state.activeAnnouncements = [];
    },
  },
});

export const { setActiveAnnouncementsLoading, setActiveAnnouncements, setActiveAnnouncementsError, clearActiveAnnouncements } =
  announcementSlice.actions;
export default announcementSlice.reducer;

export const getActiveAnnouncements = (storeId?: string) => {
  async function thunk(dispatch: AppDispatch) {
    dispatch(setActiveAnnouncementsLoading(true));

    try {
      const activeAnnouncements = await announcementTransport.getActiveAnnouncements(storeId);

      dispatch(setActiveAnnouncements(activeAnnouncements));
    } catch (error) {
      const _error = error as IError;

      dispatch(setActiveAnnouncementsError(_error));
    } finally {
      dispatch(setActiveAnnouncementsLoading(false));
    }
  }

  return thunk;
};
